import { CartData, CartSdkConfig } from '../types';

export class NotImplementedCart implements CartSdkConfig {
  onApplyDiscount(): Promise<{ success: boolean }> {
    throw new Error('Ecommerce API not implemented');
  }

  onLoadCart(): Promise<CartData> {
    throw new Error('Ecommerce API not implemented');
  }
}
